const heroTags = ['明星娱乐', '综艺现场', '商业财经', '社会民生', '直播网红'];

export default function Hero() {
  return (
    <section id="top" className="relative w-full overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=warm%20abstract%20editorial%20background%20with%20soft%20cream%20and%20coral%20gradient%20waves%2C%20subtle%20grain%20texture%2C%20minimal%20magazine%20cover%20vibe%2C%20large%20soft%20light%20glows%2C%20no%20text%2C%20no%20faces%2C%20elegant%20and%20calm&width=1600&height=760&seq=gua-hero-2026&orientation=landscape"
          alt="每日看瓜编辑部暖色渐变背景"
          className="h-full w-full object-cover"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-background-50/70 via-background-50/40 to-background-50"></div>
      </div>

      <div className="container-x relative flex flex-col items-center pt-32 pb-16 md:pt-44 md:pb-24 text-center">
        <p className="inline-flex items-center gap-2 rounded-full bg-accent-100 px-4 py-1.5 text-xs font-medium text-accent-900 ring-1 ring-accent-200">
          <i className="ri-fire-fill text-sm" aria-hidden="true"></i>
          每日瓜田 · 已更新 6 条新动态
        </p>

        <h1 className="mt-6 max-w-3xl font-heading text-4xl md:text-6xl font-bold leading-tight text-foreground-950">
          把复杂瓜田，
          <span className="text-primary-600">捋成清晰时间线</span>
        </h1>

        <p className="mt-5 max-w-2xl text-sm md:text-base leading-relaxed text-foreground-700">
          每日看瓜事件梳理专区：从起因到发酵再到结局，全经过复盘、始末细节一次讲透。
          不用再翻上百条碎片帖子，帮你快速补完全部背景。
        </p>

        <div className="mt-8 flex flex-col sm:flex-row items-center gap-3">
          <a
            href="#timeline"
            className="inline-flex whitespace-nowrap items-center gap-2 rounded-md bg-primary-500 px-6 py-3 text-sm font-medium text-background-50 transition-colors hover:bg-primary-600"
          >
            看今日事件时间线
            <i className="ri-arrow-right-line" aria-hidden="true"></i>
          </a>
          <a
            href="#review"
            className="inline-flex whitespace-nowrap items-center gap-2 rounded-md border border-background-300 bg-background-50/70 px-6 py-3 text-sm font-medium text-foreground-800 transition-colors hover:border-primary-300 hover:text-primary-700"
          >
            读最新全经过复盘
          </a>
        </div>

        <ul className="mt-8 flex flex-wrap items-center justify-center gap-2">
          {heroTags.map((t) => (
            <li
              key={t}
              className="rounded-full bg-background-100/80 px-3 py-1 text-xs text-secondary-700 ring-1 ring-background-200"
            >
              #{t}
            </li>
          ))}
        </ul>
      </div>
    </section>
  );
}